
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsSubCategory2Grid extends Serenity.EntityGrid<CsSubCategory2Row, any> {
        protected getColumnsKey() { return CsSubCategory2Columns.columnsKey; }
        protected getDialogType() { return CsSubCategory2Dialog; }
        protected getIdProperty() { return CsSubCategory2Row.idProperty; }
        protected getInsertPermission() { return CsSubCategory2Row.insertPermission; }
        protected getLocalTextPrefix() { return CsSubCategory2Row.localTextPrefix; }
        protected getService() { return CsSubCategory2Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        
    }
}